import React, { useState, useEffect } from 'react';
import './App.css';
import { getApiUrl } from './config';
import Header from './components/Header';
import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import QuranClassesFee from './pages/QuranClassesFee';
import OurTutors from './pages/OurTutors';
import MolanaHafizKaleemUllah from './pages/MolanaHafizKaleemUllah';
import MolanaHafizQariOsamaHussein from './pages/MolanaHafizQariOsamaHussein';
import QariaSadafSarfaraz from './pages/QariaSadafSarfaraz';
import AalimaQariaYousra from './pages/AalimaQariaYousra';
import FreeTrial from './pages/FreeTrial';
import Locations from './pages/Locations';
import OnlineQuranClassesInNewyork from './pages/OnlineQuranClassesInNewyork';
import OnlineQuranClassesCanada from './pages/OnlineQuranClassesCanada';
import OnlineQuranClassesTexas from './pages/OnlineQuranClassesTexas';
import OnlineQuranClassesCalifornia from './pages/OnlineQuranClassesCalifornia';
import OnlineQuranClassesFlorida from './pages/OnlineQuranClassesFlorida';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfUse from './pages/TermsOfUse';
import PayFeeOnline from './pages/PayFeeOnline';
import Blog from './pages/Blog';
import BlogDetail from './pages/BlogDetail';
import NooraniQaidaCourse from './pages/NooraniQaidaCourse';
import QuranReadingClasses from './pages/QuranReadingClasses';
import TajweedCourse from './pages/TajweedCourse';
import QuranMemorizationCourse from './pages/QuranMemorizationCourse';
import QuranTranslationClasses from './pages/QuranTranslationClasses';
import BlogsAdmin from './pages/BlogsAdmin';
import Cart from './pages/Cart';
import NotFound from './pages/NotFound';
import ContactUs from './pages/ContactUs';
import Usa from './pages/Usa';
import Ca from './pages/Ca';
import ThankYouEnrollment from './pages/ThankYouEnrollment';
import Footer from './components/Footer';
import AlQuranLessonChatbot from './components/AlQuranLesson_Chatbot';

import { FaWhatsapp } from 'react-icons/fa';

// Patch history.pushState and replaceState to dispatch custom events
const patchHistory = () => {
  const pushState = window.history.pushState;
  window.history.pushState = function (...args) {
    pushState.apply(window.history, args);
    window.dispatchEvent(new Event('pushstate'));
  };

  const replaceState = window.history.replaceState;
  window.history.replaceState = function (...args) {
    replaceState.apply(window.history, args);
    window.dispatchEvent(new Event('replacestate'));
  };
};

if (typeof window !== 'undefined') {
  patchHistory();
}

// Normalize path: strip trailing slash (except for root "/")
const normalizePath = (path) => (path !== '/' && path.endsWith('/') ? path.slice(0, -1) : path);

function App() {
  const [currentPath, setCurrentPath] = useState(normalizePath(window.location.pathname));

  useEffect(() => {
    const metadata = {
      '/': {
        title: 'Online Quran Classes in USA | Learn Quran Tajweed Online',
        description: "Online Quran classes in the USA. Learn Quran online with Al Quran Lesson's online Quran academy. 1-on-1 certified tutors. Get your 3-day free trial now!",
        canonical: 'https://alquranlesson.com/'
      },
      '/about-us': {
        title: 'About Us - Al Quran Lesson',
        description: 'Meet our expert Quran teachers with 10+ years experience. Learn about our teaching methodology and mission to spread Islamic knowledge.',
        canonical: 'https://alquranlesson.com/about-us/'
      },
      '/noorani-qaida-course': {
        title: 'Noorani Qaida Course Online For Kids & Adults in the USA',
        description: 'Learn Noorani Qaida online from home with certified male & female tutors. Live one-on-one classes for kids & adults in the USA. Book a 3-day free trial today!',
        canonical: 'https://alquranlesson.com/noorani-qaida-course/'
      },
      '/quran-reading-classes-online-for-kids-and-adults': {
        title: 'Online Quran Recitation Course In the USA | Al Quran Lesson',
        description: 'Online Quran recitation course for kids & adults with certified Hafiz tutors. Live one-on-one quran recitation classes, Tajweed included. Get free 3-day trial now!',
        canonical: 'https://alquranlesson.com/quran-reading-classes-online-for-kids-and-adults/'
      },
      '/online-tajweed-classes-tajweed-course': {
        title: '#1 Online Tajweed Course | Learn Quran With Tajweed Online',
        description: 'Looking for an online Tajweed course for your kids or yourself to learn Quran with Tajweed? Get a 3-day free trial & improve Quran reading with tajweed rules.',
        canonical: 'https://alquranlesson.com/online-tajweed-classes-tajweed-course/'
      },
      '/quran-memorization-classes-course': {
        title: 'Online Quran Memorization Classes USA with Certified Huffaz',
        description: 'Join the best online Quran memorization classes in the USA. Hifz Quran online with certified male and female tutors. Get a 3-day free trial now.',
        canonical: 'https://alquranlesson.com/quran-memorization-classes-course/'
      },
      '/quran-translation-classes': {
        title: 'Learn Quran Tafseer Online | Quran Translation Classes',
        description: 'Learn Quran tafseer online with experienced tutors. Join our free online Quran translation classes & explore the meaning of each verse through tafseer lessons.',
        canonical: 'https://alquranlesson.com/quran-translation-classes/'
      },
      '/quran-classes-fee': {
        title: 'Quran Classes Fee & Study Plan - Al Quran Lesson',
        description: 'Explore our fee packages and study plans to personalized your Quran lessons. Meet with our experienced tutors to excel in Quranic education.',
        canonical: 'https://alquranlesson.com/quran-classes-fee/'
      },
      '/blog': {
        title: 'Online Quran Blog | Learn & Explore Quranic Insights',
        description: 'Explore articles on Quran learning, Tajweed, Hifz & Islamic knowledge. Our blog offers tips for students, parents & anyone deepening Quran understanding online.',
        canonical: 'https://alquranlesson.com/blog/'
      },
      '/locations': {
        title: 'Locations We Serve - Al Quran Lesson',
        description: 'Discover the locations we serve at Al Quran Lesson. We offer online Quran classes with expert tutors for students across multiple regions worldwide.',
        canonical: 'https://alquranlesson.com/locations/'
      },
      '/online-quran-classes-in-newyork': {
        title: 'Best Online Quran Classes In New York | 16+ Years Of Experience',
        description: 'Get affordable & flexible online Quran classes in New York, USA. The premier destination for learning the Quran online with expert male or female tutors.',
        canonical: 'https://alquranlesson.com/online-quran-classes-in-newyork/'
      },
      '/online-quran-classes-canada': {
        title: 'Online Quran Classes in Canada for Kids & Adults, 3 Day Free',
        description: 'Join trusted online Quran classes in Canada for kids & adults. Learn Quran with Tajweed from qualified tutors. Flexible schedules. Start 3-day free trial today!',
        canonical: 'https://alquranlesson.com/online-quran-classes-canada/'
      },
      '/online-quran-classes-texas': {
        title: '3 Days Free Online Quran Classes In Texas with Certified Tutors',
        description: 'Al Quran Lesson offers live, one-on-one online Quran classes in Texas for kids and adults with certified male and female tutors with a 3-day free trial.',
        canonical: 'https://alquranlesson.com/online-quran-classes-texas/'
      },
      '/online-quran-classes-california': {
        title: '3 Days Free Online Quran Classes In California',
        description: 'Al Quran Lesson offers live, one-on-one online Quran classes for kids and adults in California with certified male and female tutors with a 3-day free trial.',
        canonical: 'https://alquranlesson.com/online-quran-classes-california/'
      },
      '/florida-online-quran-classes': {
        title: 'Online Quran Classes in Florida With a 3-Day Free Trial',
        description: 'Join online Quran classes in Florida with Al Quran Lesson. Expert male & female tutors, one-on-one classes, flexible timings & a 3-day free trial. Book now!',
        canonical: 'https://alquranlesson.com/florida-online-quran-classes/'
      },
      '/usa': {
        title: 'Online Quran Classes in USA for Kids & Adults | Al Quran Lesson',
        description: 'Join Al Quran Lesson for online Quran classes in the USA. Certified male & female tutors, flexible schedules for EST/CST/PST. Book your 3-day free trial now.',
        canonical: 'https://alquranlesson.com/usa/',
        noindex: true
      },
      '/ca': {
        title: 'Online Quran Classes in Canada for Kids & Adults | Al Quran Lesson',
        description: 'Join Al Quran Lesson for online Quran classes in Canada. Certified male & female tutors, flexible schedules. Book your 3-day free trial now.',
        canonical: 'https://alquranlesson.com/ca/',
        noindex: true
      },
      '/our-tutors': {
        title: 'Quran Teachers Online | Certified Male & Female Tutors',
        description: 'Learn from certified Quran teachers online. Ijazah-holders, graduates, fluent in English, & trained to teach kids and adults with patience. Start a free trial today.',
        canonical: 'https://alquranlesson.com/our-tutors/'
      },
      '/our-tutors/molana-hafiz-kaleem-ullah': {
        title: 'Molana Hafiz Kaleem Ullah | Quran Teacher & Islamic Scholar',
        description: 'Learn Quran online with Molana Hafiz Kaleem Ullah, a qualified Islamic scholar specializing in Tajweed, Hifz, Tafsir, Hadith, and Islamic studies.',
        canonical: 'https://alquranlesson.com/our-tutors/molana-hafiz-kaleem-ullah/'
      },
      '/our-tutors/molana-hafiz-qari-osama-hussein': {
        title: 'Molana Hafiz Qari Osama Hussein | Quran & Islamic Tutor',
        description: 'Learn Quran online with Molana Hafiz Qari Osama Hussein, a certified Hafiz scholar specializing in Tajweed, Hifz, Tafsir, Hadith, Fiqh, & Islamic studies.',
        canonical: 'https://alquranlesson.com/our-tutors/molana-hafiz-qari-osama-hussein/'
      },
      '/our-tutors/qaria-sadaf-sarfaraz': {
        title: 'Qaria Sadaf Sarfaraz | Online Quran Teacher for Kids & Adults',
        description: 'Learn the Quran with Qaria Sadaf Sarfaraz, a certified online Quran teacher for kids & adults, specializing in Noorani Qaida with Tajweed & Quran completion.',
        canonical: 'https://alquranlesson.com/our-tutors/qaria-sadaf-sarfaraz/'
      },
      '/our-tutors/aalima-qaria-yousra': {
        title: 'Aalima Qaria Yousra | Certified Scholar & Tajweed Specialist',
        description: 'Learn Quran online with Aalima Qaria Yousra, a certified Islamic scholar from Darul Uloom Rahmania, specializing in Hifz, Tajweed, Arabic Grammar, & Hadith.',
        canonical: 'https://alquranlesson.com/our-tutors/aalima-qaria-yousra/'
      },
      '/free-trial': {
        title: 'Online Quran Classes: Get 3 Days Free Trial - No Card Needed',
        description: 'Get a 3 days free trial on learning Quran online. Get expert guidance with our experienced tutors. No card or payment needed. Start your Quranic journey now.',
        canonical: 'https://alquranlesson.com/free-trial/'
      },
      '/pay-fee-online': {
        title: 'Pay Fee Online - Al Quran Lesson',
        description: 'Pay Fee Online - Al Quran Lesson',
        canonical: 'https://alquranlesson.com/pay-fee-online/'
      },
      '/privacy-policy': {
        title: 'Privacy Policy - Al Quran Lesson',
        description: 'Privacy Policy - Al Quran Lesson',
        canonical: 'https://alquranlesson.com/privacy-policy/'
      },
      '/terms-of-use': {
        title: 'Terms of Use - Al Quran Lesson',
        description: 'Terms of Use - Al Quran Lesson',
        canonical: 'https://alquranlesson.com/terms-of-use/'
      },
      '/thank-you-enrollment-successful': {
        title: 'Thank You - Al Quran Lesson',
        description: '',
        canonical: 'https://alquranlesson.com/thank-you-enrollment-successful/',
        noindex: true
      },
      '/cart': {
        title: 'Shopping Cart - Al Quran Lesson',
        description: 'View your selected Quran class package and proceed with secure checkout.',
        canonical: 'https://alquranlesson.com/cart/',
        noindex: true
      }
    };

    const currentMeta = metadata[currentPath];
    if (currentMeta) {
      document.title = currentMeta.title;

      let metaDesc = document.querySelector('meta[name="description"]');
      if (!metaDesc) {
        metaDesc = document.createElement('meta');
        metaDesc.setAttribute('name', 'description');
        document.head.appendChild(metaDesc);
      }
      metaDesc.setAttribute('content', currentMeta.description);

      let linkCanonical = document.querySelector('link[rel="canonical"]');
      if (!linkCanonical) {
        linkCanonical = document.createElement('link');
        linkCanonical.setAttribute('rel', 'canonical');
        document.head.appendChild(linkCanonical);
      }
      linkCanonical.setAttribute('href', currentMeta.canonical);

      let metaRobots = document.querySelector('meta[name="robots"]');
      if (!metaRobots) {
        metaRobots = document.createElement('meta');
        metaRobots.setAttribute('name', 'robots');
        document.head.appendChild(metaRobots);
      }
      if (currentMeta.noindex) {
        metaRobots.setAttribute('content', 'noindex, nofollow');
      } else {
        metaRobots.setAttribute('content', 'index, follow');
      }

      // Open Graph
      let ogTitle = document.querySelector('meta[property="og:title"]');
      if (ogTitle) ogTitle.setAttribute('content', currentMeta.title);

      let ogDesc = document.querySelector('meta[property="og:description"]');
      if (ogDesc) ogDesc.setAttribute('content', currentMeta.description);

      let ogUrl = document.querySelector('meta[property="og:url"]');
      if (ogUrl) ogUrl.setAttribute('content', currentMeta.canonical || window.location.href);

      // Twitter
      let twitterTitle = document.querySelector('meta[name="twitter:title"]');
      if (twitterTitle) twitterTitle.setAttribute('content', currentMeta.title);

      let twitterDesc = document.querySelector('meta[name="twitter:description"]');
      if (twitterDesc) twitterDesc.setAttribute('content', currentMeta.description);
    }
  }, [currentPath]);

  useEffect(() => {
    fetch(getApiUrl('/blogs'))
      .then((res) => {
        if (!res.ok) throw new Error('API down');
        return res.json();
      })
      .then((data) => {
        window.__BLOGS_CACHE__ = data;
      })
      .catch((err) => console.error('Error prefetching blogs list:', err));
  }, []);

  useEffect(() => {
    const handleLocationChange = () => {
      setCurrentPath(normalizePath(window.location.pathname));

      // Auto scroll to top when page changes unless there is a hash anchor target
      if (!window.location.hash) {
        window.scrollTo({ top: 0, behavior: 'instant' });
      }
    };

    // Initial check
    if (!window.location.hash) {
      window.scrollTo({ top: 0, behavior: 'instant' });
    }

    // Scroll to section hash if we navigated from /about-us back to Home with a hash
    if (window.location.pathname === '/' && window.location.hash) {
      const hash = window.location.hash;
      setTimeout(() => {
        const id = hash.substring(1);
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }

    window.addEventListener('popstate', handleLocationChange);
    window.addEventListener('pushstate', handleLocationChange);
    window.addEventListener('replacestate', handleLocationChange);

    // Also listen to hashchange for local anchor scroll triggers on home page
    const handleHashChange = () => {
      if (window.location.pathname === '/' && window.location.hash) {
        const id = window.location.hash.substring(1);
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
    };
    window.addEventListener('hashchange', handleHashChange);

    return () => {
      window.removeEventListener('popstate', handleLocationChange);
      window.removeEventListener('pushstate', handleLocationChange);
      window.removeEventListener('replacestate', handleLocationChange);
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, [currentPath]);

  const handleGlobalClick = (e) => {
    if (e.defaultPrevented) return;
    const anchor = e.target.closest('a');
    if (anchor) {
      const href = anchor.getAttribute('href');
      // If it's an internal path-based link, prevent reload and push state
      if (href && href.startsWith('/') && !href.startsWith('//')) {
        e.preventDefault();
        window.history.pushState({}, '', href);
      }
    }
  };


  const renderPage = () => {
    if (currentPath === '/about-us') {
      return <AboutUs />;
    } else if (currentPath === '/quran-classes-fee') {
      return <QuranClassesFee />;
    } else if (currentPath === '/our-tutors') {
      return <OurTutors />;
    } else if (currentPath === '/our-tutors/molana-hafiz-kaleem-ullah') {
      return <MolanaHafizKaleemUllah />;
    } else if (currentPath === '/our-tutors/molana-hafiz-qari-osama-hussein') {
      return <MolanaHafizQariOsamaHussein />;
    } else if (currentPath === '/our-tutors/qaria-sadaf-sarfaraz') {
      return <QariaSadafSarfaraz />;
    } else if (currentPath === '/our-tutors/aalima-qaria-yousra') {
      return <AalimaQariaYousra />;
    } else if (currentPath === '/free-trial') {
      return <FreeTrial />;
    } else if (currentPath === '/locations') {
      return <Locations />;
    } else if (currentPath === '/online-quran-classes-in-newyork') {
      return <OnlineQuranClassesInNewyork />;
    } else if (currentPath === '/online-quran-classes-canada') {
      return <OnlineQuranClassesCanada />;
    } else if (currentPath === '/online-quran-classes-texas') {
      return <OnlineQuranClassesTexas />;
    } else if (currentPath === '/online-quran-classes-california') {
      return <OnlineQuranClassesCalifornia />;
    } else if (currentPath === '/florida-online-quran-classes') {
      return <OnlineQuranClassesFlorida />;
    } else if (currentPath === '/usa') {
      return <Usa />;
    } else if (currentPath === '/ca') {
      return <Ca />;
    } else if (currentPath === '/privacy-policy') {
      return <PrivacyPolicy />;
    } else if (currentPath === '/terms-of-use') {
      return <TermsOfUse />;
    } else if (currentPath === '/pay-fee-online') {
      return <PayFeeOnline />;
    } else if (currentPath === '/blog') {
      return <Blog />;
    } else if (currentPath === '/contact-us') {
      return <ContactUs />;
    } else if (currentPath === '/noorani-qaida-course') {
      return <NooraniQaidaCourse />;
    } else if (currentPath === '/quran-reading-classes-online-for-kids-and-adults') {
      return <QuranReadingClasses />;
    } else if (currentPath === '/online-tajweed-classes-tajweed-course') {
      return <TajweedCourse />;
    } else if (currentPath === '/quran-memorization-classes-course') {
      return <QuranMemorizationCourse />;
    } else if (currentPath === '/quran-translation-classes') {
      return <QuranTranslationClasses />;
    } else if (currentPath === '/admin/blogs') {
      return <BlogsAdmin />;
    } else if (currentPath === '/thank-you-enrollment-successful') {
      return <ThankYouEnrollment />;
    } else if (currentPath === '/cart') {
      return <Cart />;
    } else if (currentPath.startsWith('/') && currentPath.length > 1) {
      const slug = currentPath.substring(1).replace(/\/$/, "");
      if (slug.includes('/')) {
        return <NotFound />;
      }
      return <BlogDetail slug={slug} />;
    } else {
      return <Home />;
    }
  };

  const isUsaPage = currentPath === '/usa';
  const isCaPage = currentPath === '/ca';

  return (
    <div className="App" onClick={handleGlobalClick}>
      {!isUsaPage && !isCaPage && <Header currentPath={currentPath} />}
      {renderPage()}
      {!isUsaPage && !isCaPage && <Footer currentPath={currentPath} />}

      {/* Floating WhatsApp Button */}
      <a
        href="https://web.whatsapp.com/send?phone=17164577657"
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Contact us on WhatsApp"
      >
        <FaWhatsapp className="whatsapp-icon" />
      </a>

      {/* Al Quran Lesson AI Chatbot */}
      {/* <AlQuranLessonChatbot /> */}
    </div>
  );
}


export default App;

